import script from "./Purchase.vue?vue&type=script&lang=ts&setup=true"
export * from "./Purchase.vue?vue&type=script&lang=ts&setup=true"

import "../assets/css/purchase.css?vue&type=style&index=0&id=5a037bf5&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a037bf5"]])

export default __exports__